import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import useApiRequest from './useApiRequest.jsx';
import { domain } from './Domain.jsx';
import notify from './Nots.jsx';
import { GridLoader } from 'react-spinners';

const Activation = () => {
    const { getRequest, loading, error } = useApiRequest();
    const { uid, token } = useParams();
    const navigate = useNavigate();

    const [activationMessage, setActivationMessage] = useState(null);

    useEffect(() => {
        activateAccount();
    }, []); // Empty dependency ensures it runs once

    // Loading state while waiting for the params to be available.
    if (!uid || !token) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="text-xl text-gray-600">Loading...</div>
            </div>
        );
    }

    const endpoint = `${domain}/accounts/activate/${uid}/${token}`;

    // Handle the account activation logic
    const activateAccount = async () => {
        try {
            const req = await getRequest(endpoint);
            console.log(req)
            console.log(req)

            if (req.status === 200) {
                setActivationMessage(req.body.message);
                notify(req.body.message, "success");
                // Optional redirect after activation
                setTimeout(() => {
                    navigate('/login'); // Redirect to login after activation
                }, 3000);
            } else {
                setActivationMessage(req.details?.error || "Something went wrong.");
                notify(req.details?.error || "Something went wrong.", "error");
            }
        } catch (err) {
            setActivationMessage("Failed to activate account. Please try again.");
            notify("Failed to activate account. Please try again.", "error");
        }
    };

    
    return (
        <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
            <div className="bg-white p-4 rounded shadow w-100" style={{ maxWidth: '400px' }}>
                <div className="d-flex justify-content-center align-items-center">
                    <img src="/images/logo.png" className="rounded-circle" style={{ width: '250px'}} alt="logo" />
                </div>
                <h1 className="fs-5 fw-semibold text-dark mb-4 text-center">Account Activation</h1>

                {/* Loading State */}
                {loading && (
                    <div className="text-center text-muted mb-4">Activating your account...</div>
                )}

                {/* Success/Error Message */}
                {activationMessage && (
                    <div className={`mb-4 p-3 rounded text-center text-white ${activationMessage.includes("Failed") ? "bg-danger" : "bg-success"}`}>
                        {activationMessage}
                    </div>
                )}

                {/* Information display */}
                {!loading && !activationMessage && (
                    <div className="text-center fs-5 text-dark">
                        <div className="d-flex justify-content-center align-items-center">
                            <GridLoader color="#4fa94d" size={50} aria-label="Loading Spinner" />
                        </div>
                        <p className="small text-muted mt-3 mb-4">Please wait while we activate your account.</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default Activation